import noop from 'lodash/noop';

import { QuestionTypeEnum } from '@/types/schema';

import ENPSRating from '../../../components/ENPSRating';
import {
  QuestionEntityEditorProps,
  SurveyQuestionsField,
} from '../../../views/UserSurveyEditor/components/BlocksList/types';

const RatingField: SurveyQuestionsField = {
  type: QuestionTypeEnum.Rating,
  Editor: (props: QuestionEntityEditorProps) => (
    <ENPSRating ratingScale={props.question.settings?.ratingScale ?? undefined} onChange={noop} />
  ),
};

export default RatingField;
